<template>
  <div>
    <div class="buttons">
      <b-tooltip
        v-for="item in buttons"
        :key="item.key"
        :label="item.help"
        :delay="500"
        type="is-dark"
        size="is-large"
        position="is-bottom"
        multilined
        class="action-tip"
      >
        <b-button
          :type="item.type"
          :icon-left="item.icon"
          :disabled="item.disabled"
          @click="click(item.key)"
        >
          {{ item.label }}
        </b-button>
      </b-tooltip>
      <slot />
    </div>

    <b-modal
      :active="modal === 'register'"
      has-modal-card
      trap-focus
      :can-cancel="cancelOptions"
      @close="close"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Inregistrare in R.E.S.D.P.S.</p>
        </header>
        <section class="modal-card-body">
          <p>
            Dupa inregistrare datele se schimba doar prin rectificare cu motiv,
            iar numarul ramane ocupat si daca dosarul se anuleaza.
          </p>
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="busy" @click="close">Renunta</b-button>
          <b-button type="is-success" :loading="busy" @click="confirmRegister">
            Da
          </b-button>
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active="modal === 'verdict'"
      has-modal-card
      trap-focus
      :can-cancel="cancelOptions"
      @close="close"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Verdict bunuri/debite</p>
        </header>
        <section class="modal-card-body">
          <b-field>
            <b-radio v-model="verdict" :native-value="true">
              Are bunuri sau debite — sesizarea se transmite Camerei
            </b-radio>
          </b-field>
          <b-field>
            <b-radio v-model="verdict" :native-value="false">
              Fara bunuri si fara debite — dosarul se va clasa
            </b-radio>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="busy" @click="close">Renunta</b-button>
          <b-button type="is-info" :loading="busy" @click="confirmVerdict"
            >Salveaza</b-button
          >
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active="modal === 'classify'"
      has-modal-card
      trap-focus
      :can-cancel="cancelOptions"
      @close="close"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Clasare</p>
        </header>
        <section class="modal-card-body">
          <p>Dosarul se claseaza. La Observatii se adauga mentiunea:</p>
          <blockquote class="mt-2 has-text-weight-semibold">
            {{ classificationMention }}
          </blockquote>
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="busy" @click="close">Renunta</b-button>
          <b-button type="is-dark" :loading="busy" @click="confirmClassify"
            >Claseaza</b-button
          >
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active="modal === 'chamber'"
      has-modal-card
      trap-focus
      :can-cancel="cancelOptions"
      @close="close"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Inregistrare la Camera notarilor</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Camera notarilor *">
            <b-select
              v-model="chamber.notaryChamberId"
              expanded
              placeholder="Alegeti camera"
            >
              <option v-for="item in chambers" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Numar *">
            <b-input
              v-model="chamber.chamberRegistrationNumber"
              maxlength="50"
            />
          </b-field>
          <b-field label="Data *">
            <b-datepicker
              v-model="chamber.chamberRegistrationDate"
              locale="ro"
              :max-date="today"
              placeholder="Alegeti data"
              icon="calendar-today"
            />
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="busy" @click="close">Renunta</b-button>
          <b-button type="is-success" :loading="busy" @click="confirmChamber"
            >Salveaza</b-button
          >
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active="modal === 'generate'"
      has-modal-card
      trap-focus
      :can-cancel="cancelOptions"
      @close="close"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Generare S.D.P.S.</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Camera notarilor *">
            <b-select
              v-model="generateChamberId"
              expanded
              placeholder="Alegeti camera"
            >
              <option v-for="item in chambers" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="busy" @click="close">Renunta</b-button>
          <b-button type="is-link" :loading="busy" @click="confirmGenerate"
            >Genereaza</b-button
          >
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active="modal === 'cancel'"
      has-modal-card
      trap-focus
      :can-cancel="cancelOptions"
      @close="close"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Anulare dosar</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Motivul anularii *">
            <b-input v-model="cancelReason" type="textarea" maxlength="500" />
          </b-field>
          <p class="has-text-grey">Numarul din registru ramane ocupat.</p>
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="busy" @click="close">Renunta</b-button>
          <b-button type="is-danger" :loading="busy" @click="confirmCancel"
            >Anuleaza dosarul</b-button
          >
        </footer>
      </div>
    </b-modal>

    <modal-box
      :is-active="modal === 'delete'"
      title="Stergere ciorna"
      body-text="Ciorna dosarului"
      :trash-object-name="deceased"
      body-suffix="va fi stearsa definitiv."
      confirm-text="Sterge ciorna"
      @confirm="confirmDelete"
      @cancel="close"
    />
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import SuccessionService from "@/services/succession.service";
import { notify } from "@/helpers/notify";
import {
  describeError,
  isDuplicateCnp,
  isReloadable,
} from "@/helpers/resdpsErrors";
import { actionHelp } from "@/helpers/resdpsHelp";
import {
  ACTION_LABELS,
  CLASSIFICATION_MENTION,
  allowedActions,
  canClassify,
  formatDate,
  formatDeceased,
  fromApiDate,
  missingForChamberRegistration,
  missingForRegistration,
  toApiDate,
} from "@/helpers/resdps";
import ModalBox from "@/components/ModalBox";

// Ordinea butoanelor (spec E, 5.5); fiecare apare doar daca matricea din API permite actiunea.
// Etichetele vin din ACTION_LABELS, iar textul tooltip-ului din actionHelp.
const BUTTONS = [
  { action: "EditDraft", key: "edit", type: "is-primary", icon: "pencil" },
  {
    action: "Register",
    key: "register",
    type: "is-success",
    icon: "book-plus",
  },
  {
    action: "DeleteDraft",
    key: "delete",
    type: "is-danger",
    icon: "trash-can",
  },
  {
    action: "RecordAssetsVerdict",
    key: "verdict",
    type: "is-info",
    icon: "scale-balance",
  },
  { action: "Classify", key: "classify", type: "is-dark", icon: "archive" },
  {
    action: "RecordChamberRegistration",
    key: "chamber",
    type: "is-success",
    icon: "bank",
  },
  {
    action: "GenerateSdps",
    key: "generate",
    type: "is-link",
    icon: "file-word",
  },
  {
    action: "Rectify",
    key: "rectify",
    type: "is-warning",
    icon: "file-document-edit",
  },
  { action: "Cancel", key: "cancel", type: "is-danger", icon: "cancel" },
];

export default {
  name: "SuccessionFileActions",
  components: { ModalBox },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    today: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      modal: null,
      busy: false,
      verdict: null,
      cancelReason: "",
      chamber: {
        notaryChamberId: null,
        chamberRegistrationNumber: "",
        chamberRegistrationDate: null,
      },
      chambers: [],
      generateChamberId: null,
      classificationMention: CLASSIFICATION_MENTION,
    };
  },
  computed: {
    // Un buton dezactivat isi spune motivul la finalul tooltip-ului (in locul title-ului nativ).
    buttons() {
      const allowed = allowedActions(this.detail.status);
      const states = {
        register: () => this.registerState,
        classify: () => this.classifyState,
      };
      return BUTTONS.filter((item) => allowed.indexOf(item.action) !== -1).map(
        (item) => {
          const { reason, ...state } = states[item.key]
            ? states[item.key]()
            : { disabled: false };
          const help = actionHelp(item.action);
          return {
            ...item,
            label: ACTION_LABELS[item.action],
            ...state,
            help: reason ? help + " " + reason : help,
          };
        }
      );
    },
    registerState() {
      return missingForRegistration(this.detail).length > 0
        ? {
            disabled: true,
            reason:
              "Butonul devine activ dupa ce completati campurile marcate ●.",
          }
        : { disabled: false };
    },
    // Ajutor de afisare; API-ul verifica din nou verdictul si data (RESDPS-CLASSIFY-TOO-EARLY).
    classifyState() {
      if (this.detail.hasAssetsOrDebts !== false) {
        return {
          disabled: true,
          reason:
            "Mai intai trebuie consemnat verdictul fara bunuri si fara debite.",
        };
      }
      if (!canClassify(this.detail, this.today)) {
        const from = formatDate(this.detail.classificationAvailableFrom);
        return {
          disabled: true,
          label: "Clasare posibila din " + from,
          reason: "Devine posibila din " + from + ".",
        };
      }
      return { disabled: false };
    },
    cancelOptions() {
      return this.busy ? [] : ["escape", "outside"];
    },
    deceased() {
      return formatDeceased(this.detail);
    },
  },
  methods: {
    click(key) {
      if (key === "edit" || key === "rectify") {
        this.$emit(key);
        return undefined;
      }
      if (key === "chamber") return this.openChamber();
      if (key === "generate") return this.openGenerate();
      if (key === "verdict") {
        this.verdict =
          typeof this.detail.hasAssetsOrDebts === "boolean"
            ? this.detail.hasAssetsOrDebts
            : null;
      }
      if (key === "cancel") this.cancelReason = "";
      this.modal = key;
      return undefined;
    },
    async openChamber() {
      this.chamber = {
        notaryChamberId: this.detail.notaryChamberId,
        chamberRegistrationNumber: this.detail.chamberRegistrationNumber || "",
        chamberRegistrationDate: fromApiDate(
          this.detail.chamberRegistrationDate
        ),
      };
      this.modal = "chamber";
      await this.ensureChambers();
    },
    async openGenerate() {
      this.generateChamberId = this.detail.notaryChamberId;
      this.modal = "generate";
      await this.ensureChambers();
    },
    // Lista camerelor se incarca o singura data si e refolosita de fereastra de Inregistrare
    // la Camera si de cea de Generare.
    async ensureChambers() {
      if (this.chambers.length > 0) return;
      try {
        this.chambers = await SuccessionService.listNotaryChambers();
      } catch (error) {
        notify.error(this, describeError(error).message);
      }
    },
    close() {
      if (!this.busy) this.modal = null;
    },
    async run(request, successMessage) {
      this.busy = true;
      try {
        const updated = await request();
        this.busy = false;
        this.modal = null;
        notify.success(
          this,
          typeof successMessage === "function"
            ? successMessage(updated)
            : successMessage
        );
        this.$emit("updated", updated);
      } catch (error) {
        this.busy = false;
        this.handleError(error);
      }
    },
    handleError(error) {
      const described = describeError(error);
      if (isReloadable(described)) {
        this.modal = null;
        this.$emit("stale", described.message);
        return;
      }
      if (isDuplicateCnp(described)) {
        this.modal = null;
        this.$emit("duplicate", {
          successionFileId: described.data.successionFileId,
          registration: described.data.registration,
        });
      }
      notify.error(this, described.message);
    },
    confirmRegister() {
      return this.run(
        () =>
          SuccessionService.registerFile(
            this.detail.id,
            this.detail.rowVersion
          ),
        (updated) => "Dosarul a primit numarul " + updated.registration + "."
      );
    },
    confirmVerdict() {
      if (this.verdict !== true && this.verdict !== false) {
        notify.error(this, "Alegeti una dintre optiuni.");
        return undefined;
      }
      return this.run(
        () =>
          SuccessionService.recordAssetsVerdict(
            this.detail.id,
            this.verdict,
            this.detail.rowVersion
          ),
        "Verdictul a fost salvat."
      );
    },
    confirmClassify() {
      return this.run(
        () =>
          SuccessionService.classifyFile(
            this.detail.id,
            this.detail.rowVersion
          ),
        "Dosarul a fost clasat."
      );
    },
    confirmChamber() {
      const values = {
        notaryChamberId: this.chamber.notaryChamberId,
        chamberRegistrationNumber: (
          this.chamber.chamberRegistrationNumber || ""
        ).trim(),
        chamberRegistrationDate: toApiDate(
          this.chamber.chamberRegistrationDate
        ),
      };
      if (missingForChamberRegistration(values).length > 0) {
        notify.error(this, "Completati camera, numarul si data.");
        return undefined;
      }
      return this.run(
        () =>
          SuccessionService.recordChamberRegistration(
            this.detail.id,
            values,
            this.detail.rowVersion
          ),
        "Inregistrarea la Camera a fost salvata."
      );
    },
    // Genereaza sesizarea S.D.P.S. si o descarca imediat. Daca descarcarea esueaza, generarea
    // ramane reusita: dosarul e deja actualizat si emis, doar descarcarea se poate relua din
    // tab-ul Documente.
    async confirmGenerate() {
      if (!this.generateChamberId) {
        notify.error(this, "Alegeti camera notarilor.");
        return undefined;
      }
      this.busy = true;
      try {
        const { detail, document } = await SuccessionService.generateDocument(
          this.detail.id,
          {
            notaryChamberId: this.generateChamberId,
            rowVersion: this.detail.rowVersion,
          }
        );
        this.busy = false;
        this.modal = null;
        notify.success(this, "Sesizarea S.D.P.S. a fost generata.");
        this.$emit("updated", detail);
        try {
          const downloaded = await SuccessionService.downloadDocument(
            this.detail.id,
            document.id,
            document.fileName
          );
          saveAs(downloaded.blob, downloaded.name);
        } catch (error) {
          notify.error(this, describeError(error).message);
        }
      } catch (error) {
        this.busy = false;
        this.handleError(error);
      }
    },
    confirmCancel() {
      const reason = (this.cancelReason || "").trim();
      if (!reason) {
        notify.error(this, "Completati motivul anularii.");
        return undefined;
      }
      return this.run(
        () =>
          SuccessionService.cancelFile(
            this.detail.id,
            reason,
            this.detail.rowVersion
          ),
        "Dosarul a fost anulat."
      );
    },
    async confirmDelete() {
      this.busy = true;
      try {
        await SuccessionService.deleteFile(this.detail.id);
        this.busy = false;
        this.modal = null;
        notify.success(this, "Ciorna a fost stearsa.");
        this.$emit("deleted");
      } catch (error) {
        this.busy = false;
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
/* Bulma distanteaza doar butoanele care nu sunt ultimele in parinte; aici fiecare buton sta in tooltip-ul lui. */
.buttons .action-tip:not(:last-child) {
  margin-right: 0.5rem;
}
/* Un buton dezactivat nu primeste evenimente de mouse; asa hover-ul ajunge la tooltip. */
.action-tip ::v-deep button[disabled] {
  pointer-events: none;
}
</style>
